import { styled } from "goober";

// Space for buttons: 2 × 24px buttons + 4px gap + 8px margin + 8px breathing room
export const INPUT_BUTTONS_WIDTH = 68;
export const WORKFLOW_INPUT_WIDTH = 600;
export const WORKFLOW_INPUT_HEIGHT = 96;

export const InputContainer = styled("div")`
  position: relative;
  padding: 8px;
  background-color: var(--surface-primary);
  box-shadow: var(--elevation-low);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 12px;
`;
